import { LeadMagnetAdCard } from '../../../chrome/LeadMagnetAdCard'
import { LeadMagnetScheduleCTA } from '../../../chrome/LeadMagnetScheduleCTA'
import type { Winner } from '../types'

function getVariant(winner: Winner) {
  if (winner === 'buy') {
    return {
      eyebrow: 'Buying looks like the move',
      headline: 'See how much house you can actually afford',
      body: 'A financial advisor can help you understand if you can afford the home you want without sacrificing the rest of your financial life.',
    }
  }

  return {
    eyebrow: 'Renting might be smarter right now',
    headline: 'What should you do with the savings?',
    body: 'If renting frees up capital, a financial advisor can help you put that money to work with a long-term plan.',
  }
}

export function AdCard({ winner }: { winner: Winner }) {
  const variant = getVariant(winner)
  return (
    <LeadMagnetAdCard
      eyebrow={variant.eyebrow}
      headline={variant.headline}
      body={variant.body}
      cta={
        <LeadMagnetScheduleCTA segmentElement="Rent Vs Buy Ad Card" size="cta-sm" variant="cta-dark">
          Book a free intro call →
        </LeadMagnetScheduleCTA>
      }
    />
  )
}
